export const SUB_GROUP_OVERRIDE = {
  cic: 1
};
